interface RankingListProps<T> {
  title: string;
  items: T[];
  labelOf: (item: T) => string;
  countOf: (item: T) => number;
  emptyLabel?: string;
}

export function RankingList<T>({
  title, items, labelOf, countOf, emptyLabel = 'Sem dados no período.',
}: RankingListProps<T>) {
  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
      {items.length === 0 ? (
        <p className="mt-3 text-sm text-gray-500">{emptyLabel}</p>
      ) : (
        <ol className="mt-3 space-y-2">
          {items.map((it, idx) => (
            <li key={idx} className="flex items-center justify-between text-sm">
              <span className="flex items-center gap-2 truncate text-gray-800">
                <span className="w-5 shrink-0 text-right font-mono text-xs text-gray-500">
                  {idx + 1}.
                </span>
                <span className="truncate">{labelOf(it)}</span>
              </span>
              <span className="ml-2 shrink-0 rounded bg-gray-100 px-2 py-0.5 font-mono text-xs">
                {countOf(it)}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
